import React, { useEffect, useState } from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { MailAddressForm } from "@/shared/components/text-box/mail-address-form";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { useShareAccountGroup } from "@/features/my-data/hooks/use-share-account-group";
import { useAccountGroupsContext } from "@/features/accounts/account-group/contexts/account-groups-context";
import { useInputValidation } from "@/shared/hooks/use-input-validation";
import { SimpleForm } from "@/shared/components/text-box/simple-form";

interface Props {
  onTapCloseModal: () => void;
  onTapCompleteModal: () => void;
}

export const ShareAccountGroupModal = ({ onTapCloseModal, onTapCompleteModal }: Props) => {
  const {
    targetAccountGroup,
  } = useAccountGroupsContext();

  const {
     invitationMail,
     setInvitationMail,
     invitationComment,
     setInvitationComment,
     isActiveInviteButton,
     onClickSendMail,
     changeSendMailButtonState
  } = useShareAccountGroup({onTapCompleteModal});

  useEffect(() => {
   changeSendMailButtonState();
  }, [invitationMail]);

  const { validate } = useInputValidation("deleteOver4Bytes");
  const [isComposing, setIsComposing] = useState(false);

  const onChangeComment = (value: string, composing = isComposing) => {
    value = validate(value, composing);
    setInvitationComment(value);
  }

  return (
    <BasePageModal
      className="md-group-invitation"
      handleClose={onTapCloseModal}
      title="データ共有"
      bottomChildren={
        <BaseRoundButton
          buttonText="招待メールを送信"
          className="btn-mail"
          onClick={() => {
            onClickSendMail(
              targetAccountGroup.accountGroupId,
              invitationMail,
              invitationComment.trim()
            );
          }}
          isActive={isActiveInviteButton}
        />
      }
      disableOverlayClose={true}
    >
      <h2>
        以下の宛先に招待メールを送信します
      </h2>
      <dl>
        <SimpleForm
          id="accountGroupName"
          value={targetAccountGroup.accountGroupsName}
          isReadOnly={true}
          title="グループ名"
          onChange={() => {}}
          labelEnable={true}
          descriptionType={true}
        />
      </dl>
      <ul className="invitation">
        <li>
          <MailAddressForm
            title="招待する相手"
            placeholder="メールアドレスを入力"
            id="invitationMail"
            onChange={(value) => {setInvitationMail(value);}}
          />
        </li>
        <li>
          <label htmlFor="invitationComment">メッセージ（任意）</label>
          <textarea
            id="invitationComment"
            value={invitationComment}
            onChange={(e) => {onChangeComment(e.target.value);}}
            onCompositionStart={() => setIsComposing(true)}
            onCompositionEnd={() => {
              setIsComposing(false);
              onChangeComment(invitationComment, false);
            }}
            maxLength={2000}
          />
        </li>
      </ul>
      <p>
        送信相手が招待を受け入れるとデータ共有を開始します
      </p>
    </BasePageModal>
  );
};
